export const InstructionType = Object.freeze({
  COMPLETE_SUCCESS: 1,
  CLOSE_OUT: 2,
  SKIP: 3,
  SAMPLE: 4,
  SAMPLE_OR_CLOSE: 5,
  SNOOZE: 6,
  UNSNOOZE: 7,
  CUSTOM_NEXT_TASK: 8,
  REPEAT: 9,
  TRANSITION: 10,
  SKIP_N: 11,
  HOLD: 12,
  RELEASE_HOLD: 13,
  REJECT_AND_REASSIGN: 14,
  REDISCOVERY_SNOOZE: 15,
  UPDATE_DUE_DATE: 16,
  CODER_RESPONSE: 17,
})

export const TaskStatus = Object.freeze({
  ACTIVE: 1,
  SNOOZED: 4,
  ON_HOLD: 7,
})

export const NEEDS_DATE = [InstructionType.SNOOZE, InstructionType.UPDATE_DUE_DATE]
